export default {
  lstTab: {
    overview: 'Overview',
    orderStatistic: 'Order Statistic',
    foreign: 'Foreign',
    proprietary: 'Proprietary',
    statisticByInvestor: 'Statistic by Investor',
  },

  rateList: {
    FromDate: '01/01/2019',
    ToDate: '01/03/2019',
  },

  lstTitleDate: {
    from: 'From',
    to: 'To',
  },

  defaultRateFrom: 'FromDate',
  defaultRateTo: 'ToDate',

  priceDataTableOverview: {
    DATE: 'DATE',
    LAST: 'LAST',
    CHANGE: 'CHANGE',
    PERCENT_PRICE_CHANGE: '%1D CHANGE',
    OPEN: 'OPEN',
    HIGH: 'HIGH',
    LOW: 'LOW',
    OPEN_INDEX: 'OPEN',
    HIGH_INDEX: 'HIGH',
    LOW_INDEX: 'LOW',
    AVERAGE_PRICE: 'AVG. PRICE',
    MATCHED_VOLUME: 'MATCHED<br> VOLUME', // have space after <br>
    MATCHED_VALUE: 'MATCHED<br> VALUE', // have space after <br>
    PUT_THROUGH_VOL: 'PUT THROUGH<br> VOL.', // have space after <br>
    PUT_THROUGH_VALUE: 'PUT THROUGH<br> VALUE', // have space after <br>
    TOTAL_VOL: 'TOTAL VOL.',
    TOTAL_VALUE: 'TOTAL VALUE',
  },

  priceDataTableOrderStatistic: {
    DATE: 'DATE',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'LAST',
    CHANGE: 'CHANGE',
    PERCENT_PRICE_CHANGE: '%1D CHANGE',
    NR_OF_BUY_ORDER: 'NR.OF<br> BUY ORDER', // have space after <br>
    BUY_VOL: 'BUY VOL',
    VOLUMN_BUY_ORDER: 'VOLUME/<br>BUY ORDER',
    NR_OF_SELL_ORDER: 'NR.OF<br> SELL ORDER', // have space after <br>
    SELL_VOL: 'SELL VOL',
    VOLUMN_SELL_ORDER: 'VOLUME/<br>SELL ORDER',
    NET_VOL: 'NET VOL.',
  },

  priceDataTableForeign: {
    DATE: 'DATE',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'LAST',
    CHANGE: 'CHANGE',
    PERCENT_PRICE_CHANGE: '%1D CHANGE',
    BUY_ORDER_VOL: 'TOTAL BUY ORDER <br> VOL.', // have space after <br>
    BUY_ORDER_VALUE: 'TOTAL BUY ORDER <br> VALUE', // have space after <br>
    SELL_ORDER_VOL: 'TOTAL SELL ORDER <br> VOL.', // have space after <br>
    SELL_ORDER_VALUE: 'TOTAL SELL ORDER <br> VALUE', // have space after <br>
    NET_VOLUME: 'TOTAL NET <br> VOLUME',
    NET_VALUE: 'TOTAL NET <br> VALUE',
    OWNED_RATIO: 'OWNED RATIO',
    FOREIGN_ROOM: 'FOREIGN ROOM',

    BUY_VOL_MATCHED: 'MATCH BUY <br> VOLUME',
    BUY_VALUE_MATCHED: 'MATCH BUY  <br> VALUE',
    SELL_VOL_MATCHED: 'MATCH SELL <br> VOLUME',
    SELL_VALUE_MATCHED: 'MATCH SELL <br> VALUE',
    BUY_VOL_DEAL: 'DEAL BUY <br> VOLUME',
    BUY_VALUE_DEAL: 'DEAL BUY <br> VALUE',
    SELL_VOL_DEAL: 'DEAL SELL <br> VOLUME',
    SELL_VALUE_DEAL: 'DEAL SELL <br> VALUE',
    NET_MATCH_VOL: 'NET MATCH <br> VOLUME',
    NET_MATCH_VALUE: 'NET MATCH <br> VALUE',
    NET_DEAL_VOL: 'NET DEAL <br> VOLUME',
    NET_DEAL_VALUE: 'NET DEAL <br> VALUE',
  },

  priceDataTableProprietary: {
    DATE: 'DATE',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'LAST',
    CHANGE: 'CHANGE',
    PERCENT_PRICE_CHANGE: '%1D CHANGE',
    BUY_VOL: 'TOTAL BUY VOL.',
    BUY_VALUE: 'TOTAL BUY VALUE',
    SELL_VOL: 'TOTAL SELL VOL.',
    SELL_VALUE: 'TOTAL SELL VALUE',
    NET_VOL: 'TOTAL NET VOL.',
    NET_VALUE: 'TOTAL NET VALUE',

    BUY_VOL_MATCHED: 'MATCH BUY <br> VOLUME',
    BUY_VALUE_MATCHED: 'MATCH BUY  <br> VALUE',
    SELL_VOL_MATCHED: 'MATCH SELL <br> VOLUME',
    SELL_VALUE_MATCHED: 'MATCH SELL <br> VALUE',
    BUY_VOL_DEAL: 'DEAL BUY <br> VOLUME',
    BUY_VALUE_DEAL: 'DEAL BUY <br> VALUE',
    SELL_VOL_DEAL: 'DEAL SELL <br> VOLUME',
    SELL_VALUE_DEAL: 'DEAL SELL <br> VALUE',
    NET_MATCH_VOL: 'NET MATCH <br> VOLUME',
    NET_MATCH_VALUE: 'NET MATCH <br> VALUE',
    NET_DEAL_VOL: 'NET DEAL <br> VOLUME',
    NET_DEAL_VALUE: 'NET DEAL <br> VALUE',
  },

  priceDataTableStatisticByInvestor: {
    DATE: 'DATE',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'LAST',
    CHANGE: 'CHANGE',
    PERCENT_PRICE_CHANGE: '%1D CHANGE',
    NET_INDIVIDUAL_VOLUME: 'Net Individual <br> Volume',
    NET_INDIVIDUAL_VALUE: 'Net Individual  <br> Value',
    NET_INSTITUTION_VOLUME: 'Net Institution  <br> Volume',
    NET_INSTITUTION_VALUE: 'Net Institution  <br> Value',
    NET_PROPRIETARY_VOLUME: 'Net Proprietary  <br> Volume',
    NET_PROPRIETARY_VALUE: 'Net Proprietary  <br> Value',
    NET_FOREIGN_VOLUME: 'Net Foreign  <br> Volume',
    NET_FOREIGN_VALUE: 'Net Foreign  <br> Value',

    NET_INDIVIDUAL_MATCH_VOLUME: 'Net Individual <br> Match Volume',
    NET_INDIVIDUAL_MATCH_VALUE: 'Net Individual  <br> Match Value',
    NET_INSTITUTION_MATCH_VOLUME: 'Net Institution <br>  Match Volume',
    NET_INSTITUTION_MATCH_VALUE: 'Net Institution  <br> Match Value',
    NET_PROPRIETARY_MATCH_VOLUME: 'Net Proprietary  <br> Match Volume',
    NET_PROPRIETARY_MATCH_VALUE: 'Net Proprietary  <br> Match Value',
    NET_FOREIGN_MATCH_VOLUME: 'Net Foreign  <br> Match Volume',
    NET_FOREIGN_MATCH_VALUE: 'Net Foreign  <br> Match Value',
  },

  listTimeRangeByKey: {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
  },

  indexInfo: {
    Open: 'O',
    Hight: 'H',
    Low: 'L',
    Bid: 'BID',
    Ask: 'ASK',
  },

  footerText1:
    'Price: x 1,000. Volume: x 1,000. Value: x 1,000,000. Exercise Date is marked with the arterisk.',
  footerText2: 'Price: x 1,000. Volume: x 1,000. Value: x 1,000,000',
  footerTextDerivative: ' Value: x 1,000,000.',
  // proprietaryNotice: {
  //   title: 'Notice',
  //   content:
  //     'From March, 1st, 2022; Proprietary Data is replaced by Local Institutional Data <br/> (already including Proprietary Data).',
  // },
  // statInvestorNotice: {
  //   title: 'Notice',
  //   content:
  //     'From March, 1st, 2022; Proprietary Data is included in Local Institutional Data.',
  // },
};
